<template>
  <div id="appH5D">
    <div class="inner-box">
      <aliPlayer
        :source="source"
        v-if="chapter_type == 1"
        @videoWatch="videoWatch"
      ></aliPlayer>
      <aliPlayerHeadTail
        v-else-if="chapter_type == -1 || chapter_type == -2"
        :source="chapter_type == -2 ? endVideo : startVideo"
        @videoEnd="videoEnd"
      ></aliPlayerHeadTail>
      <div class="head" v-else>
        <h1>
          <i class="doc"></i>
          <span>{{ chapter_type == 2 ? $t('learnExam') : $t('IllustrationType') }}</span>
        </h1>
        <div class="des">{{ chapter_title }}</div>
        <p class="enter" v-if="chapter_type == 2" @click="enterNextPage">
          {{$t('Enter')}} {{$t('learnExam')}}
        </p>
        <p class="enter" v-else-if="chapter_type == 4" @click="enterNextPage">
          {{$t('Enter')}} {{$t('IllustrationType')}}
        </p>
      </div>
      <div class="mid">
        <h2>
          {{ data.res_title }}
          <div class="fatherdiv">
            <div class="persentdiv">
              <div class="persentleft"></div>
              <div class="persentright wth0"></div>
            </div>
            <div class="num">0%</div>
          </div>
        </h2>
        <p
          :class="{ 'over-hide-mul': rowNum > 2 && !isOpen }"
          class="xq"
          v-if="data.res_desc"
        >
          {{ data.res_desc }}
        </p>
        <span @click="isOpen = !isOpen" v-show="rowNum > 2" v-if="data.res_desc"
          >{{ isOpen ? $t('collapse') : $t('Deatil') }}...</span
        >
        <div class="course-info" v-if="showPdfList">
          <img src="../../assets/img/h5/course.png" alt="">
          <span class="info">课程资料({{data.materials.length}})</span>
          <span class="through" @click="previewPdf(data.materials[0])">查看</span>
        </div>
      </div>
      <div class="bottom">
        <div
          :class="chapter_type == -1 ? 'start-video-active' : 'start-video'"
          @click="fixedAnimate('start')"
        >
          {{$t('Opening')}}
        </div>
        <div class="list" v-for="(item, index) in data.part_list" :key="index">
          <div class="tit" @click="changeCollapse(item, !item.isOpen)">
            <span :class="{ rol: item.isOpen }"></span>{{ item.part_title }}
          </div>
          <ul v-show="!item.isOpen">
            <li
              :class="{ active: activeShow == el.chapter_id }"
              @click="doChapter(el, i, index)"
              v-for="(el, i) in item.chapter_list"
              :key="i"
              :id="activeShow == el.chapter_id ? 'activeChapter' : ''"
            >
              <span
                :class="{
                  video: el.chapter_type == 1,
                  test: el.chapter_type == 2,
                  tuwen: el.chapter_type == 4,
                }"
              ></span>
              <p class="over-hide">{{ el.chapter_title }}</p>
              <i
                :class="{
                  complete: el.is_finished == 1,
                  uncompletes: el.is_finished == 0,
                }"
              ></i>
            </li>
          </ul>
        </div>
        <div
          :class="chapter_type == -2 ? 'start-video-active' : 'start-video'"
          @click="fixedAnimate('end')"
        >
          {{$t('EndVideo')}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import aliPlayer from 'components/aliPlayer'
import aliPlayerHeadTail from 'components/aliPlayerHeadTail'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      isOpen: false, // 描述显隐
      activeShow: 0, // 列表选中状态
      chapter_type: 0, // 小节类型
      chapter_title: '', // 小节名称
      chapter_id: '', // 小节id
      cur_zj_index: 0, // 当前的章节
      cur_xj_index: 0, // 当前的小节
      source: '', // 视频地址
      rowNum: 0, // 描述行数
      scrollingTop: 0, // 上次滚动高度
      progressState: true, // 滚动条显示隐藏
      showPdfList: true
    }
  },
  watch: {
    studyProgress () {
      this.percent(Math.round(this.$store.state.studyProgress * 100))
    }
  },
  computed: {
    ...mapState({
      video_finished: state => state.video_finished,
      studyProgress: state => state.studyProgress
    }),
    cur_data () {
      return this.$store.state.cur_data
    },
    next_data () {
      return this.$store.state.next_data
    },
    cur_chap_index () {
      return this.$store.state.currentChapterIndex
    },
    cur_part_index () {
      return this.$store.state.currentPartIndex
    },
    // 学习小节进度
    progressNumber () {
      return Math.round(this.$store.state.studyProgress * 100)
    },
    // 进度条宽度
    progressLength () {
      return {
        width: this.$store.state.studyProgress > 0 ? `${this.$store.state.studyProgress * 100}%` : '.02rem'
      }
    }
  },
  created () {
    this.showPdfList = this.data.materials && this.data.materials.length > 0 && this.$global_config.course_info.default
    if (this.$route.query.chapter_id) {
      for (let li of this.data.part_list) {
        for (let item of li.chapter_list) {
          if (this.$route.query.chapter_id == item.chapter_id) {
            this.$store.commit('cur_data', item)
            this.$store.commit('setFixedVideoPlayer', true)
            return
          }
        }
      }
    }
  },
  beforeMount () {
    if ((window.orientation == 90 || window.orientation == -90) && this.$global_config.is_landscape) {
      this.$nextTick(() => {     
        this.$router.replace({ path: '/h5Rindex', query: { ...this.$route.query } })
      })
    }
    /* 初始化默认选中第一章第一小节 */
    let lessonLocation = this.$store.state.lessonLocation
    let chapterStatusStr = lessonLocation.split('||')[0]
    let currentChapter = lessonLocation.split('||')[1]
    let chapterStatusArr = chapterStatusStr.split('|')
    let pIndex = currentChapter.split('-')[0]
    let cIndex = currentChapter.split('-')[1]
    if (pIndex != 0 || cIndex != 0 || chapterStatusArr.join('').indexOf('1') >= 0) {
      if (!this.cur_data) this.$store.commit('cur_data', this.data.part_list[pIndex].chapter_list[cIndex])
      this.data.part_list.map((li, index) => {
        li.chapter_list.map((item, ind) => {
          item.is_finished = chapterStatusArr[index][ind]
          return item
        })
        return li
      })
      this.$store.commit('setFixedVideoPlayer', true)
    }
    if (this.$store.state.fixedVideoPlayer) {
      this.activeShow = this.cur_data.chapter_id
      this.chapter_type = this.cur_data.chapter_type
      this.chapter_title = this.cur_data.chapter_title
      this.chapter_id = this.cur_data.chapter_id
      if (this.chapter_type == 1) { // 视频类型
        this.source = this.cur_data.file_path[0]
        this.$store.commit('video_url', this.source)
      }
      this.$router.replace({ path: '/h5Dindex', query: { chapter_id: this.chapter_id } })
    } else {
      this.fixedAnimate('start')
      this.$store.commit('setInFixedVideo', 'auto')
    }
    // 进度条初始化
    this.setProgressLength()
  // this.$store.commit('cur_data',this.data.part_list[0].chapter_list[0]);
  },
  mounted () {
    this.percent(Math.round(this.$store.state.studyProgress * 100))
    //  window.addEventListener('scroll', this.handleScroll(this.setProgressState), true);
    this.$nextTick(() => {
      // 描述 高度/行高=文本行数
      this.rowNum = Math.round($('.xq').height() / parseFloat($('.xq').css('line-height')))
      if (document.getElementById('activeChapter')) document.getElementById('activeChapter').scrollIntoViewIfNeeded(false)
    })
  },
  methods: {
    previewPdf(item) {
      this.$router.push({ name: 'preview_d', query: { title: item.title, path: item.path, redirect: this.$route.name, query: {...this.$route.query} } })
    },
    // 视频播放完成
    videoWatch (bul) {
      this.activeShow = this.next_data.chapter_id
      this.chapter_type = this.next_data.chapter_type
      this.chapter_title = this.next_data.chapter_title
      if (this.next_data.chapter_type == 1) {
        this.source = this.next_data.file_path[0]
        this.$store.commit('video_url', this.source)
      }
      // 改变小节完成状态
      // this.setLessonLocation(this.cur_part_index,this.cur_chap_index)

      let curPartIndex = Number(this.cur_part_index)
      let curChapIndex = Number(this.cur_chap_index)
      let nexPartIndex = curPartIndex
      let nexChapIndex = curChapIndex
      if (curChapIndex < this.data.part_list[curPartIndex].chapter_list.length - 1) {
        curChapIndex = curChapIndex + 1
      } else if (curPartIndex < this.data.part_list.length - 1) {
        curPartIndex = curPartIndex + 1
        curChapIndex = 0
      } else {
        this.fixedAnimate('end')
      }
      if (curChapIndex < this.data.part_list[curPartIndex].chapter_list.length - 1) {
        nexPartIndex = curPartIndex
        nexChapIndex = curChapIndex + 1
      } else if (curPartIndex < this.data.part_list.length - 1) {
        nexPartIndex = curPartIndex + 1
        nexChapIndex = 0
      }
      this.$store.commit('cur_data', this.next_data)
      this.$store.commit('currentChapterIndex', curChapIndex)
      this.$store.commit('currentPartIndex', curPartIndex)
      this.$store.commit('next_data', this.data.part_list[nexPartIndex].chapter_list[nexChapIndex])
    },
    // 渲染百分比
    percent (percent) {
      if (percent > 100) {
        percent = 0
        $('.persentdiv').removeClass('clip-auto')
        $('.persentright').addClass('wth0')
      } else if (percent > 50) {
        $('.persentdiv').addClass('clip-auto')
        $('.persentright').removeClass('wth0')
      }
      $('.persentleft').css('transform', 'rotate(' + 3.6 * percent + 'deg)')
      $('.num').text(percent + '%')
    },
    doChapter (el, i, index) { // 小节点击操作
      this.activeShow = el.chapter_id
      this.chapter_type = el.chapter_type
      this.chapter_title = el.chapter_title
      this.chapter_id = el.chapter_id
      this.$store.commit('videoTime', 0)
      this.$store.commit('videoHeadTime', 0)
      if (el.chapter_type == 1) {
        this.source = el.file_path[0]
        this.$store.commit('video_url', this.source)
        // 改变小节完成状态
        // this.setLessonLocation(index, i)
        this.$set(el, 'is_finished', 1)
      } else {
        this.setLessonLocation(index, i, false)
      }
      this.cur_zj_index = index
      this.cur_xj_index = i
      this.$store.commit('cur_data', el)
      this.$store.commit('currentPartIndex', this.cur_zj_index)
      this.$store.commit('currentChapterIndex', this.cur_xj_index)
      if (this.cur_xj_index < this.data.part_list[this.cur_zj_index].chapter_list.length - 1) {
        this.$store.commit('next_data', this.data.part_list[this.cur_zj_index].chapter_list[this.cur_xj_index + 1])
      } else if (this.cur_zj_index < this.data.part_list.length - 1) {
        this.$store.commit('next_data', this.data.part_list[this.cur_zj_index + 1].chapter_list[0])
      } else {
        this.$store.commit('next_data', el)
      }
      // this.$router.replace({path: '/h5Dindex',query: {chapter_id: el.chapter_id}});
    },
    changeCollapse (item, bool) {
      this.$set(item, 'isOpen', bool)
      this.$forceUpdate()
    },
    // 进入小测验或图文
    enterNextPage () {
      this.$store.commit('setFixedVideoPlayer', true)
      if (this.chapter_type == 2) {
        this.$router.push({
          path: '/h5Dindex/test', query: { chapter_id: this.chapter_id }
        })
      } else if (this.chapter_type == 4) {
        this.$router.push({
          path: '/h5Dindex/tuwen', query: { chapter_id: this.chapter_id }
        })
      }
    },
    // 出品结束动画
    fixedAnimate (type) {
      this.$router.replace({ path: '/h5Dindex' })
      this.$store.commit('setInFixedVideo', 'click')
      this.activeShow = -1
      this.cur_xj_index = -1
      // 开始结束动画链接
      if (type == 'start') {
        this.chapter_type = -1
      } else {
        this.chapter_type = -2
      }
    },
    // 出品动画播放结束
    videoEnd () {
      console.log(789, this.cur_data.chapter_type)
      if (this.$store.state.inFixedVideo == 'click' && this.chapter_type == -1) {
        return this.doChapter(this.data.part_list[0].chapter_list[0], 0, 0)
      }
      if (this.$store.state.inFixedVideo == 'auto' && this.chapter_type == -1) {
        this.activeShow = this.cur_data.chapter_id
        this.chapter_type = this.cur_data.chapter_type
        this.chapter_title = this.cur_data.chapter_title
        this.chapter_id = this.cur_data.chapter_id
        // this.$set(this.cur_data,"is_finished",1)
        if (this.chapter_type == 1) { // 视频类型
          this.source = this.cur_data.file_path[0]
          this.$store.commit('video_url', this.source)
        }
      }
    },
    // 函数防抖
    handleScroll (func, wait = 100) {
      let timer = null
      return function () {
        var context = this
        var args = arguments
        if (!timer) {
          timer = setTimeout(function () {
            func.apply(context, args)
            timer = null
          }, wait)
        }
      }
    },
    // 修改学习进度显示状态
    setProgressState () {
      // 页面滚动距顶部距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                      document.body.scrollTop
      let scroll = scrollTop - this.scrollingTop
      this.scrollingTop = scrollTop
      let scrollBottom = document.getElementById('appH5D').offsetHeight - window.innerHeight - scrollTop
      if ((scroll < 0 || scrollTop == 0) && scrollBottom > 2) {
        this.progressState = true
      } else {
        this.progressState = false
      }
    }
  },
  components: {
    aliPlayer,
    aliPlayerHeadTail
  }
}
</script>

<style lang="less" scoped>
#appH5D {
  color: #252631;
  font-size: 0.26rem;
  // height:100vh;
  overflow: auto;
  // -webkit-overflow-scrolling: touch;
  background: #f8f8f8;
  .inner-box {
    // height:auto;
    min-height: 100%;
  }
  .aliplayer {
    width: 100%;
    height: 4.2rem;

    // 20191230
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
  }
  .head {
    width: 100%;
    height: 4.2rem;
    background-color: @basic-color;
    color: #fff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // 20191230
    position: fixed;
    left: 0;
    top: 0;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    z-index: 999;
    h1 {
      font-size: 0.3rem;
      i {
        display: inline-block;
        width: 0.28rem;
        height: 0.28rem;
        vertical-align: middle;
        margin-right: 0.1rem;
        &.test {
          background: url("../../assets/img/h5/test.png") no-repeat center /
            contain;
        }
        &.doc {
          background: url("../../assets/img/h5/doc.png") no-repeat center /
            contain;
        }
        &.tuwen {
          background: url("../../assets/img/h5/tuwen.png") no-repeat center /
            contain;
        }
      }
      span {
        vertical-align: middle;
      }
    }
    .des {
      margin: 0.3rem 0 0.5rem;
      padding: 0 0.38rem;
      box-sizing: border-box;
      max-height: 2rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
    .enter {
      display: inline-block;
      border-radius: 40px;
      min-width: 2.6rem;
      padding: 0 .3rem;
      box-sizing: border-box;
      height: 0.8rem;
      line-height: 0.8rem;
      background-color: #fff;
      color: @basic-color;
      font-size: 0.3rem;
      text-align: center;
    }
  }
  .mid {
    // width: 7.5rem;
    width: 100%;
    border-bottom: 0.1rem solid #f8f8f8;
    padding: 0.3rem 0.4rem .2rem;
    box-sizing: border-box;
    background: #fff;
    overflow-x: hidden;
    margin-top: 4.2rem;
    position: relative;
    h2 {
      font-size: 0.36rem;
      // word-break:break-word;
      padding-bottom: 0.14rem;
      width: 90%;
    }
    p {
      line-height: 0.48rem;
      color: #666;
      transition: all 0.5s;
      word-break: break-word;
    }
    span {
      color: @basic-color;
    }
    .course-info{
      margin-top: .4rem;
      padding-top: .2rem;
      // margin-bottom: .1rem;
      border-top: 1px solid #eeeeee;
      background: #fff;
      img{
        width: .26rem;
        margin-top: -.1rem;
      }
      .info{
        color: #252631;
        font-size: .3rem;
        margin-left: .11rem;
      }
      .through{
        width: .9rem;
        height: .4rem;
        line-height: .45rem;
        text-align: center;
        background-color: #ffffff;
        border-radius: .05rem;
        border: solid 1px #005587;
        display: block;
        color: #005587;
        font-size: .22rem;
        float: right;
      }
    }
  }
  .bottom {
    padding: 0.5rem 0.4rem 1rem;
    background: #fff;
    .start-video {
      padding-bottom: 0.4rem;
      padding-left: 0.05rem;
      display: flex;
      align-items: center;
      font-size: 0.28rem;
      &::before {
        content: "";
        width: 0.1rem;
        height: 0.1rem;
        background: #aaa;
        border-radius: 50%;
        margin-right: 0.2rem;
      }
    }
    .start-video-active {
      .start-video;
      color: @basic-color;
      &::before {
        background: @basic-color;
      }
    }
    .tit {
      font-size: 0.3rem;
      font-weight: bold;
      margin-bottom: 0.4rem;
      span {
        display: inline-block;
        width: 0.2rem;
        height: 0.2rem;
        background: url("../../assets/img/h5/more.png") no-repeat center /
          contain;
        margin-right: 0.1rem;
        transition: all 0.5s;
        transform: rotate(90deg);
        &.rol {
          // transform:rotate(90deg);
          transform: rotate(0deg);
        }
      }
    }
    ul {
      li {
        padding-left: 0.34rem;
        padding-bottom: 0.4rem;
        span {
          display: inline-block;
          width: 0.25rem;
          height: 0.25rem;
          vertical-align: middle;
          margin-right: 0.1rem;
          &.test {
            background: url("../../assets/img/h5/tests.png") no-repeat center /
              contain;
          }
          &.video {
            background: url("../../assets/img/h5/video.png") no-repeat center /
              contain;
          }
          &.tuwen {
            background: url("../../assets/img/h5/tuwens.png") no-repeat center /
              contain;
          }
          &.doc {
            background: url("../../assets/img/h5/docs.png") no-repeat center /
              contain;
          }
        }
        p {
          display: inline-block;
          width: 5.25rem;
          vertical-align: middle;
        }
        i {
          float: right;
          display: inline-block;
          width: 0.3rem;
          height: 0.3rem;
          background: #fff;
          border: 1px solid rgba(193, 193, 193, 1);
          border-radius: 50%;
          vertical-align: middle;
          box-sizing: border-box;
          &.uncomplete {
            background: url("../../assets/img/h5/uncomplete.png") no-repeat
              center / contain;
            border: none;
          }
          &.complete {
            background: url("../../assets/img/h5/complete.png") no-repeat center /
              contain;
            border: none;
          }
        }
        &.active {
          span {
            &.test {
              background: url("../../assets/img/h5/testb@3x.png") no-repeat
                center / contain;
            }
            &.video {
              background: url("../../assets/img/h5/videob@3x.png") no-repeat
                center / contain;
            }
            &.tuwen {
              background: url("../../assets/img/h5/tuwenb@3x.png") no-repeat
                center / contain;
            }
            &.doc {
              background: url("../../assets/img/h5/docb@3x.png") no-repeat
                center / contain;
            }
          }
          p {
            color: @basic-color;
          }
        }
      }
    }
  }
}
.finish-progress {
  width: 86%;
  background: #eeeeee;
  padding: 0.2rem 0.5rem;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0.3rem;
  left: 7%;
  box-sizing: border-box;
  border-radius: 0.6rem;
  font-size: 0.24rem;
  .progress-warpper {
    flex: 1;
    margin: 0 0.3rem;
    height: 0.08rem;
    background: white;
    border-radius: 0.04rem;
    .progress-content {
      height: 100%;
      background: #005587;
      border-radius: 0.04rem;
      transition: all 0.5s;
    }
  }
}

/* 圆形进度条 */

.fatherdiv {
  width: 0.6rem;
  height: 0.6rem;
  // position: relative;
  background-color: #ddd;
  border-radius: 50%;
  // float: right;
  position: absolute;
  top: 0.28rem;
  right: 0.4rem;
}
.persentdiv {
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  position: absolute;
  clip: rect(0, 0.6rem, 0.6rem, 0.3rem);
}

.persentleft {
  position: absolute;
  width: 0.6rem;
  height: 0.6rem;
  border: 0.04rem solid #005587;
  box-sizing: border-box;
  border-radius: 50%;
  clip: rect(0, 0.3rem, 0.6rem, 0);
}

.persentright {
  position: absolute;
  width: 0.6rem;
  height: 0.6rem;
  border: 0.04rem solid #005587;
  box-sizing: border-box;
  border-radius: 50%;
  clip: rect(0, 0.6rem, 0.6rem, 0.3rem);
}

.wth0 {
  width: 0;
}

.num {
  position: absolute;
  box-sizing: border-box;
  width: 0.52rem;
  height: 0.52rem;
  line-height: 0.52rem;
  text-align: center;
  font-size: 0.2rem;
  left: 0.04rem;
  top: 0.04rem;
  border-radius: 50%;
  background-color: #fff;
  color: #005587;
  z-index: 1;
}
.clip-auto {
  clip: rect(auto, auto, auto, auto);
}
</style>
